const segment = {
  // eslint-disable-next-line
  track: (eventName: string, properties: any, options?: any): void => {
    window.analytics && window.analytics.track(eventName, properties, options);
  }
};

export default segment;
